import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Axios from "axios";
import moment from "moment";

import { url } from "../../../../config/config";
import CarouselNewArrival from "../CarouselNewArrival/CarouselNewArrival";
import { useStyles } from "./NewArrival.css";

class NewArrival extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newArrival: [],
    };
  }

  componentDidMount() {
    this.getBooks();
  }

  getBooks = async () => {
    const response = await Axios.get(`${url}/api/books`);
    if (response.data.length !== 0) {
      let newDate = moment(new Date()).format("LL");
      let oldDate = moment(new Date()).subtract(7, "days").format("LL");
      let tempData = response.data.filter(
        (book) =>
          oldDate <= moment(book.publishedDate).format("LL") &&
          moment(book.publishedDate).format("LL") <= newDate
      );
      console.log(tempData);
      this.setState({
        newArrival: tempData,
        maxSteps: tempData.length,
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { newArrival } = this.state;
    return (
      <div>
        {newArrival.length !== 0 && (
          <div className={classes.root}>
            <div
              style={{
                paddingBottom: 20,
                fontSize: 35,
                display: "flex",
                justifyContent: "center",
              }}
            >
              New Arrival
            </div>
            <div className={classes.sectionDesktop}>
              <CarouselNewArrival
                newArrival={newArrival}
                slidesPerPage={3}
                imageWidth={400}
              />
            </div>
            <div className={classes.sectionMobile}>
              <CarouselNewArrival newArrival={newArrival} slidesPerPage={1} />
            </div>
            <br />
            <div style={{ paddingLeft: 10, paddingRight: 10 }}>
              <Divider style={{ height: 10, borderRadius: 10 }} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(NewArrival));
